export default __webpack_public_path__ + "static/media/icon-settings-web.02176c80.svg";